module.exports = __webpack_public_path__ + "font/f5f2566b.woff2";